<template>
  <v-container fluid grid-list-md>
    <v-layout column px-6 py-3>
      <v-row>
        <v-col class="mb-6" cols="12">
          <span class="text-h4 font-weight-bold">{{ title }}</span>
        </v-col>
        <slot name="tabBar"/>
        <slot name="searchBar"/>
        <slot name="table"/>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
  }
}
</script>